module.exports = __webpack_public_path__ + "static/img/winter_jianjiePic.9f9a05cb.png";